// components/ScrollToTopButton.jsx
import React, { useState, useEffect } from "react";
import { ArrowUpCircle } from "lucide-react";

function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);

  const toggleVisibility = () => {
    if (window.scrollY > 300) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  return (
    visible && (
      <button onClick={scrollToTop} className="scroll-to-top">
        <ArrowUpCircle size={36} />
      </button>
    )
  );
}

export default ScrollToTopButton;
